import {useState,useEffect}  from "react";
import {   
    makeStyles,
    mergeClasses,
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    DialogTrigger,
    Button,
    TableBody,
    TableCell,
    TableRow,
    Table,
    TableHeader,
    TableHeaderCell,
    TableCellLayout,
    useFocusableGroup,
    tokens,
    Subtitle2,
    Textarea,
    Spinner,
    useToastController,
    } from "@fluentui/react-components";
import {EditRegular, DeleteRegular} from "@fluentui/react-icons";
import TimePicker from './TimePicker';
import {IsCompleteTime, DifferenceInMinutes, getHourTotals} from '../../services/TimeFunctions';
import {format, addDays} from "date-fns";
import {SetTimeEntryDetails} from '../../services/apiService';
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import TooltipWatcherWidget from "../TooltipWatcherWidget";
import { showErrorToast, showSuccessToast, TOASTER_ID } from "../../services/toastUtils";
import {formatDisplayDate} from '../../services/TimeFunctions';

const useStylesEditor = makeStyles({
    dialog: {
        width: '90vw',
        maxWidth: '800px',
        padding: '1rem',
        overflowX: 'auto',
    },
    
    infobar :{
        color: tokens.colorBrandForeground1,
        backgroundColor: tokens.colorBrandBackground2,
        padding: '3px'
    }
});

export default function EntryCellEditor(props) { 
    const{startLoad, endLoad, isDesktop, useStyles, loading, currentWeekStart, dateToggle}= useGlobalStatus();
    const globalStyles = useStyles();
    const [entry, setEntry]=useState({
            start:'',
            end: '',
            break:'',
            comments:'',
            totalMinutes: 0,
            id:0,
            startEndValidationState:'none',
            breakValidationState: 'none',
            isValid:false
    });
    const [open, setOpen] = useState(false);
    const [entryToDelete, setEntryToDelete] = useState(null);
    const [disableConfirmForAPI, setDisableConfirmForAPI] = useState(false);
    const { dispatchToast } = useToastController(TOASTER_ID);
    const [expandedId, setExpandedId] = useState(null);
    const [currentWeekTotal, setCurrentWeekTotal] = useState(0);
    const [currentDailyTotal, setCurrentDailyTotal] = useState(0);
    const [expectedtWeekTotal, setExpectedWeekTotal] = useState(0);
    const [expectedDailyTotal, setExpectedDailyTotal] = useState(0);

    const toggleRow = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
    };

    // Reset input fields when the dialog closes
    useEffect(() => {
        if (!props.dialogOpen) {
            clear(); 
        }
        else if (props.dialogOpen && props.timesheetData) {
            // Get the totals
            const totals = getHourTotals(props.timesheetData, props.leaveData, currentWeekStart);
            let dayIndex = (new Date(props.entryDay.date).getDay() + 6) % 7;
            
            const weekTotalVal = totals?.weekTotal || 0;
            const dailyTotalVal = totals?.dailyTotals[dayIndex] || 0;
            
            // Set baseline totals
            setCurrentWeekTotal(weekTotalVal);
            setCurrentDailyTotal(dailyTotalVal);
            // Seed initial expectations
            setExpectedDailyTotal(dailyTotalVal); 
            setExpectedWeekTotal(weekTotalVal); 
        }
    }, [props.dialogOpen]);

    const styles = useStylesEditor();

    const handleRowEdit = (id)=> {
        setEntry(props.entryDay.entries.find(q=> q.id === id));
    }

    const handleRowDelete = async (id)=> {
        startLoad();
        var entryToDelete = props.entryDay.entries.find(q=> q.id === id);
        // Delete from A23 DB
        var timeEntryDetail = {
            start:entryToDelete.start,
            end: entryToDelete.end,
            break:entryToDelete.break,
            comments:entryToDelete.comments,
            timeEntryDetailId:entryToDelete.id};

        var date = format(props.entryDay.date, "yyyy-MM-dd HH:mm:ss");
        let deletedBool = false;
        try {
            deletedBool = await SetTimeEntryDetails(props.entryData.taskId, date, timeEntryDetail, true);
            showSuccessToast(dispatchToast, "Successfully deleted entry");
        } catch {
            showErrorToast(dispatchToast, "Failed to delete entry");
        }

        if (deletedBool) {
            var day = {
                ...props.entryDay,
                entries: props.entryDay.entries.filter(item => item.id !== id)
            };
              props.handleUpdateWeekView(props.entryData, day); 
        } else {
            showErrorToast(dispatchToast, "Failed to delete entry");
        }
        props.suggestedStartDict[format(new Date(props.entryDay.date), 'dd/MM/yyyy')] = entry.end;
        props.setSuggestedStartDict(props.suggestedStartDict);
        endLoad();
        props.handleDialogClose();
    }
    const handleDialogCancel = () =>{
        props.handleDialogClose();
    };

    const handleDialogAdd = async () =>{
        // Validate break format before submission
        const isValidBreak = entry.break === "" || /^([01]\d|2[0-3]):([0-5]\d)$/.test(entry.break);
        if (!isValidBreak) {
            setEntry(prev => ({
                ...prev,
                breakValidationState: "error"
            }));
            return;
        }

        startLoad();
        setDisableConfirmForAPI(true);
        var timeEntryDetail = {
            start:entry.start,
            end: entry.end,
            break:entry.break,
            comments:entry.comments,
            timeEntryDetailId:entry.id};
        
        var date = format(props.entryDay.date, "yyyy-MM-dd HH:mm:ss");
        let newid = null;
        try {
            newid = await SetTimeEntryDetails(props.entryData.taskId, date, timeEntryDetail, false);
            var day = props.entryDay;
            if(entry.id===0){
                //Add a new record
                if(!isNaN(newid)){
                    entry.id= newid;
                    day.entries.push(entry);
                }
            }
             else {
                const entryIndex = day.entries.findIndex(existingEntry => existingEntry.id === entry.id);
                if (entryIndex !== -1) {
                    day.entries[entryIndex] = { ...day.entries[entryIndex], ...entry };
                }
            }
            showSuccessToast(dispatchToast, "Successfully updated entry");
            // Only close dialog if its successful, easier for a user to notice somethings wrong
            props.handleDialogClose();
            // Update the view update logic only if newid wasnt null
            if(newid != null) 
            {
                props.handleUpdateWeekView(props.entryData, day);
                props.suggestedStartDict[format(new Date(props.entryDay.date), 'dd/MM/yyyy')] = entry.end;
                props.setSuggestedStartDict(props.suggestedStartDict);
            }

        }catch {
            showErrorToast(dispatchToast, "Failed to update entry");
        }finally{
            endLoad();
            setDisableConfirmForAPI(false);
            clear();
        }
    };
    
const calculateExpectedHours = (currentEntry, existingEntry) => {
    if (existingEntry != undefined && existingEntry != null) {
        setExpectedDailyTotal(currentDailyTotal + (currentEntry.totalMinutes / 60) - (existingEntry.totalMinutes / 60));
        setExpectedWeekTotal(currentWeekTotal + (currentEntry.totalMinutes / 60) - (existingEntry.totalMinutes / 60));
    } else {
        setExpectedDailyTotal(currentDailyTotal + (currentEntry.totalMinutes / 60));
        setExpectedWeekTotal(currentWeekTotal + (currentEntry.totalMinutes / 60));
    }
}

const handleSetEntry = (source, value) => {
    var instance = { ...entry };

    switch (source) {
        case "Start":
            instance.start = value;
            break;
        case "End":
            instance.end = value;
            break;
        case "Break":
            instance.break = value;
            instance.breakValidationState = "none";
            break;
        default:
            if (value !== undefined) {
                instance.comments = value.value;
            }
            break;
    }

    // Perform the validation
    if (IsCompleteTime(instance.start) && IsCompleteTime(instance.end)) {
        var difference = DifferenceInMinutes(instance.end, instance.start);
        
        // Overlap Validation using all entries across same day
        const allEntriesSameDay = [];
        props.timesheetData.forEach(client => {
            client.projects.forEach(project => {
                project.budgets.forEach(budget => {
                    budget.timecodes.forEach(timecode => {
                        timecode.entryDays.forEach(entryDay => {
                            if (new Date(entryDay.date).toISOString().split("T")[0] === new Date(props.entryDay.date).toISOString().split("T")[0]) { 
                                allEntriesSameDay.push(...entryDay.entries);
                            }
                        });
                    });
                });
            });
        });

        if (difference < 1) {
            instance.startEndValidationState = "error";
            instance.totalMinutes = 0;
            instance.isValid = false;
        } else {
            instance.startEndValidationState = "none";
            instance.totalMinutes = difference;
            instance.isValid = true;
            let existingEntry = allEntriesSameDay.find(e => e.id === instance.id);
            calculateExpectedHours(instance, existingEntry);

            if (IsCompleteTime(instance.break)) {
                var total = DifferenceInMinutes(difference, instance.break);
                if (total < 1) {
                    instance.breakValidationState = "error";
                    instance.totalMinutes = 0;
                    instance.isValid = false;
                } else {
                    instance.breakValidationState = "none";
                    instance.totalMinutes = total;
                    instance.isValid = true;
                    calculateExpectedHours(instance, existingEntry);
                }
            }
        }

        
        
        let hasOverlap = allEntriesSameDay.some(existingEntry => {
            if (existingEntry.id !== instance.id) {
                return (
                    (instance.start >= existingEntry.start && instance.start < existingEntry.end) || 
                    (instance.end > existingEntry.start && instance.end <= existingEntry.end) || 
                    (instance.start <= existingEntry.start && instance.end >= existingEntry.end)
                );
            }
            return false;
        });

        if (hasOverlap) {
            instance.overlapValidationState = "error";
            instance.isValid = false;
        } else {
            instance.overlapValidationState = "none";
        }
    } else {
        instance.isValid = false;
    }
    setEntry(instance);
};

   
    const clear = ()=> {
        setEntry({
            start:'',
            end: '',
            break:'',
            comments:'',
            totalMinutes: 0,
            id:0,
            startEndValidationState:'none',
            breakValidationState: 'none',
            overlapValidationState: 'none',
            isValid:false
        });
    }

    const columns = [
        { columnKey: "start", label: "Start" },
        { columnKey: "end", label: "End" },
        { columnKey: "break", label: "Break" },
        { columnKey: "comments", label: "Comments" },
        { columnKey: "total", label: "Total" },
        { columnKey: "actions", label: "Actions" },
      ];

    const mobileColumns = [
        { columnKey: "start", label: "Start" },
        { columnKey: "end", label: "End" },
        { columnKey: "break", label: "Break" },
        { columnKey: "total", label: "Total" },
        { columnKey: "actions", label: "Delete" },
      ];

    const focusableGroupAttr = useFocusableGroup({
        tabBehavior: "limited-trap-focus",
    });

return (
    <Dialog open={props.dialogOpen} onOpenChange={(e, { open }) => handleDialogCancel()}>
        <DialogSurface className={styles.dialog}>
            <DialogBody>
                <DialogTitle>
                    {props.dialogOpen && props.entryDay && (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {props.entryDay.status === "empty" ? "Add new record" : "Modify record"} - {format(props.entryDay.date, "PPPP")}
                            <span style={{ fontSize: "14px", color: "#888" }}>
                                {props.entryData.projectName} - {props.entryData.taskName}
                            </span>
                        </div>
                    )}
                </DialogTitle>

                <DialogContent style={{ overflowY: 'auto'}}>
                    {props.dialogOpen && (
                        <div>
                            {isDesktop ? (
                                <Table className="editor-approval-table">
                                    <TableHeader>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableHeaderCell key={column.columnKey}>
                                                    {column.label}
                                                </TableHeaderCell>
                                            ))}
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {props.entryDay.entries.map((entry) => (
                                            <TableRow key={entry.id} onClick={() => handleRowEdit(entry.id)}>
                                                <TableCell><TableCellLayout>{entry.start}</TableCellLayout></TableCell>
                                                <TableCell><TableCellLayout>{entry.end}</TableCellLayout></TableCell>
                                                <TableCell><TableCellLayout>{entry.break}</TableCellLayout></TableCell>
                                                <TableCell><TableCellLayout>{entry.comments}</TableCellLayout></TableCell>
                                                <TableCell><TableCellLayout>{formatDisplayDate(entry.totalMinutes, dateToggle)}</TableCellLayout></TableCell>
                                                <TableCell role="gridcell" {...focusableGroupAttr}>
                                                    <TableCellLayout>
                                                        <Button icon={<EditRegular />} aria-label="Edit" onClick={() => handleRowEdit(entry.id)}></Button>


                                                        <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
                                                        <DialogTrigger disableButtonEnhancement>
                                                            <Button icon={<DeleteRegular />} aria-label="Delete" onClick={() => {setOpen(true); setEntryToDelete(entry.id);}} ></Button>
                                                        </DialogTrigger>
                                                        <DialogSurface>
                                                            <DialogBody>
                                                                <DialogTitle>Confirmation</DialogTitle>
                                                                <DialogContent>Are you sure you want to delete the entry?</DialogContent>
                                                                <DialogActions>
                                                                    <Button className={globalStyles.buttonPrimary} onClick={() => { handleRowDelete(entryToDelete); setOpen(false); }}>Yes</Button>
                                                                    <Button appearance="secondary" onClick={() => setOpen(false)}>No</Button>
                                                                </DialogActions>
                                                            </DialogBody>
                                                        </DialogSurface>
                                                    </Dialog>

                                                    </TableCellLayout>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : (
                            props.entryDay.entries.map((entry) => (
                                <div 
                                key={entry.id} 
                                style={{ 
                                    border: `1px solid ${tokens.colorNeutralStroke2}`, 
                                    borderRadius: tokens.borderRadiusMedium,
                                    overflow: 'hidden' 
                                }}
                                >
                                    <div 
                                        onClick={() => toggleRow(entry.id)}
                                        style={{ 
                                        padding: '12px', 
                                        cursor: 'pointer', 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        backgroundColor: expandedId === entry.id ? tokens.colorNeutralBackground2 : 'transparent'
                                        }}
                                    >
                                        <span><b>{entry.start} - {entry.end}</b></span>
                                        <span>{expandedId === entry.id ? '▲' : '▼'}</span>
                                    </div>

                                {expandedId === entry.id && (
                                    <div style={{ padding: '12px', borderTop: `1px solid ${tokens.colorNeutralStroke2}` }}>
                                            <Table className="editor-approval-table">
                                                <TableHeader>
                                                    <TableRow>
                                                        <TableHeaderCell>Start</TableHeaderCell>
                                                        <TableHeaderCell>End</TableHeaderCell>
                                                    </TableRow>
                                                </TableHeader>
                                                <TableBody>
                                                    <TableRow onClick={() => handleRowEdit(entry.id)}>
                                                        <TableCell>{entry.start}</TableCell>
                                                        <TableCell>{entry.end}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <Table className="editor-approval-table">
                                                <TableHeader>
                                                    <TableRow>
                                                        <TableHeaderCell>Break</TableHeaderCell>
                                                        <TableHeaderCell>Total</TableHeaderCell>
                                                    </TableRow>
                                                </TableHeader>
                                                <TableBody>
                                                    <TableRow onClick={() => handleRowEdit(entry.id)}>
                                                        <TableCell>{entry.break}</TableCell>
                                                        <TableCell>{formatDisplayDate(entry.totalMinutes, dateToggle)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <Table className="editor-approval-table"> 
                                                <TableHeader>
                                                    <TableRow>
                                                        <TableHeaderCell>Actions</TableHeaderCell>
                                                    </TableRow>
                                                </TableHeader>
                                                <TableBody>
                                                    <TableRow style={{ padding: '8px', backgroundColor: tokens.colorNeutralBackground2, display: 'flex', gap: '8px' }}>
                                                        <Button icon={<EditRegular />} onClick={() => handleRowEdit(entry.id)}>Edit</Button>
                                                        

                                                        <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
                                                        <DialogTrigger disableButtonEnhancement>
                                                            <Button icon={<DeleteRegular />} aria-label="Delete" onClick={() => {setOpen(true); setEntryToDelete(entry.id);}} />
                                                        </DialogTrigger>
                                                        <DialogSurface>
                                                            <DialogBody>
                                                                <DialogTitle>Confirmation</DialogTitle>
                                                                <DialogContent>Are you sure you want to delete the entry?</DialogContent>
                                                                <DialogActions>
                                                                    <Button className={globalStyles.buttonPrimary} onClick={() => { handleRowDelete(entryToDelete); setOpen(false); }}>Yes</Button>
                                                                    <Button appearance="secondary" onClick={() => setOpen(false)}>No</Button>
                                                                </DialogActions>
                                                            </DialogBody>
                                                        </DialogSurface>
                                                    </Dialog>


                                                    </TableRow>
                                                </TableBody>
                                            </Table>

                                    </div>
                                )}
                                </div>
                                ))
      
                            )}

                            {props.entryDay.entries.length === 0 && (
                                <div className={mergeClasses('infobar-layout', styles.infobar)}>
                                    <Subtitle2>There are no entries</Subtitle2>
                                </div>
                            )}

                            <div className="metric-container">
                                <TooltipWatcherWidget text="Estimated Hours for the week after adding an entry" direction="above-start">
                                    <div className="metric-card">
                                        <span className="metric-label">Estimated Daily Total</span>
                                        <span className="metric-value">{formatDisplayDate(expectedDailyTotal * 60, dateToggle, false)}</span>
                                    </div>
                                </TooltipWatcherWidget>
                                
                                <TooltipWatcherWidget text="Estimated Hours for the week after adding an entry" direction="above-start">
                                    <div className="metric-card">
                                        <span className="metric-label">Estimated Weekly Hours</span>
                                        <span className="metric-value">{formatDisplayDate(expectedtWeekTotal, dateToggle, true)}</span>
                                    </div>
                                </TooltipWatcherWidget>
                            </div>
                        
                            <div className="editor-form">
                                <div className="editor-format-tip">Enter Start, End, and Break times in 24-hour format (e.g. 08:30)</div>
                                <div className="editor-error-message">
                                    {(entry.overlapValidationState === "error" || entry.startEndValidationState === "error" || entry.breakValidationState === "error") ? "" : <br />}
                                    {entry.overlapValidationState === "error" ? "Time overlaps with another entry! " : ""}
                                    {entry.startEndValidationState === "error" ? "End time must be greater than start time! " : ""}
                                    {entry.breakValidationState === "error" && "Break cannot be longer than work time or incorrect format!"}
                                </div>
                                <div className="entry-editing">
                                    {
                                    isDesktop ? (
                                        <div className="entry-editing-1">
                                            <TimePicker
                                                key={"entry-start"}
                                                label={"Start"}
                                                value={entry.start}
                                                setValue={handleSetEntry}
                                                validationState={entry.overlapValidationState === "error" ? "error" : "none"}
                                                required={true}
                                                suggestedStart={props.suggestedStartDict[format(new Date(props.entryDay.date), "dd/MM/yyyy")].start}
                                            />
                                            <TimePicker
                                                key={"entry-end"}
                                                label={"End"}
                                                value={entry.end}
                                                setValue={handleSetEntry}
                                                validationState={entry.overlapValidationState === "error" ? "error" : entry.startEndValidationState}
                                                required={true}
                                                suggestedStart={props.suggestedStartDict[format(new Date(props.entryDay.date), "dd/MM/yyyy")].end}

                                            />
                                            <TimePicker
                                                key={"entry-break"}
                                                label={"Break"}
                                                value={entry.break}
                                                setValue={handleSetEntry}
                                                required={false}
                                                validationState={entry.breakValidationState}
                                                suggestedStart={"00:30"}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                        <div className="entry-editing-1">
                                            <TimePicker
                                                key={"entry-start"}
                                                label={"Start"}
                                                value={entry.start}
                                                setValue={handleSetEntry}
                                                validationState={entry.overlapValidationState === "error" ? "error" : "none"}
                                                required={true}
                                                suggestedStart={props.suggestedStartDict[format(new Date(props.entryDay.date), "dd/MM/yyyy")].start}
                                            />
                                            <TimePicker
                                                key={"entry-end"}
                                                label={"End"}
                                                value={entry.end}
                                                setValue={handleSetEntry}
                                                validationState={entry.overlapValidationState === "error" ? "error" : entry.startEndValidationState}
                                                required={true}
                                                suggestedStart={props.suggestedStartDict[format(new Date(props.entryDay.date), "dd/MM/yyyy")].end}

                                            />
                                            </div>
                                        <div className="entry-editing-2">

                                            <TimePicker
                                                key={"entry-break"}
                                                label={"Break"}
                                                value={entry.break}
                                                setValue={handleSetEntry}
                                                required={false}
                                                validationState={entry.breakValidationState}
                                                suggestedStart={"00:30"}
                                            />
                                        </div>
                                        </>
                                    )
                                    }

                                    <div className="editor-total-hours">
                                        Total Hours
                                        <TooltipWatcherWidget text="Total hours for the entry" direction="above-start">
                                            <div>{entry.totalMinutes === 0 ? "0.00hr" : formatDisplayDate(entry.totalMinutes, dateToggle)}</div>
                                        </TooltipWatcherWidget>
                                    </div>
                                </div>
                                Comments
                                <Textarea style={{ width: "100%" }} value={entry.comments} onChange={handleSetEntry} />
                            </div>
                        </div>
                    )}
                </DialogContent>

                <DialogActions>
                    <DialogTrigger disableButtonEnhancement>
                        <Button appearance="secondary" onClick={handleDialogCancel}>Cancel</Button>
                    </DialogTrigger>
                    <Button
                        disabled={!props.dialogOpen || !entry.isValid || disableConfirmForAPI}
                        icon={loading ? <Spinner size="tiny" /> : null}
                        className={globalStyles.buttonPrimary}
                        onClick={handleDialogAdd}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
);
}

